import AccountFormModal from './AccountFormModal';
import ApiKeys from './ApiKeys';
import CreateApiKeyModal from './CreateApiKeyModal';
import Deliveries from './Deliveries';
import DevelopersView from './DevelopersView';
import SecretRevealModal from './SecretRevealModal';
import WebhookEndpointFormModal from './WebhookEndpointFormModal';
import WebhookEndpoints from './WebhookEndpoints';

export default {
  AccountFormModal,
  ApiKeys,
  CreateApiKeyModal,
  Deliveries,
  DevelopersView,
  SecretRevealModal,
  WebhookEndpointFormModal,
  WebhookEndpoints,
};
